import React from 'react';
import IconButton, {
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import { Values } from '@lib/interfaces/form';
import FormItem from '@lib/components/ReactHookForm/FormItem';
import FormTemplateFieldNames from '@lib/enums/fieldNames/formTemplateFieldNames';
import Input from '@lib/components/Input/Input';
import { InputSizes } from '@lib/components/Input/enums';
import { useTranslation } from 'react-i18next';
import { onKeyDownFn } from '@lib/utils/formOptionsHelpers';
import styles from '../QuestionChecklistField/QuestionChecklistField.module.scss';

interface Props {
  isFocused?: boolean;
  onAdd: (v: Values) => void;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  onRemove: () => void;
  parentIndex: number;
  parentName: string;
  parentValue: Values[];
}

function ChecklistFieldOptions(props: Props) {
  const {
    isFocused,
    onAdd,
    onClick,
    onRemove,
    parentIndex,
    parentName,
    parentValue,
  } = props;
  const isDeleteBtnVisible = parentValue?.length > 1;
  const { t } = useTranslation();
  const componentProps = {
    autoFocus: isFocused,
    hasBorder: false,
    hasErrorAsTooltip: true,
    name: `${parentName}.${parentIndex}.${FormTemplateFieldNames.Values}.0`,
    placeholder: t('checklist-option-placeholder'),
    size: InputSizes.medium,
    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) =>
      onKeyDownFn(e, {
        onAdd,
        onRemove: isDeleteBtnVisible ? onRemove : undefined,
        index: parentIndex,
      }),
  };
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className={isDeleteBtnVisible ? styles.listItemWithDeleteBtn : undefined}
      onClick={onClick}
    >
      <FormItem
        componentProps={componentProps}
        element={Input}
        formItemClassName={styles.formItem}
        hideErrors
        name={`${parentName}.${parentIndex}.${FormTemplateFieldNames.Values}.0`}
      />
      {isDeleteBtnVisible && (
        <div className={styles.listItemDelete}>
          <IconButton
            icon="cancel"
            onClick={onRemove}
            rounded
            type={IconButtonTypes.TertiaryFilled}
          />
        </div>
      )}
    </div>
  );
}

export default ChecklistFieldOptions;
